"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function GradientCircle() {
  const isdark = useIsDark();
  return (
    <div
      className={twMerge(
        "absolute inset-0 rounded-full -z-10  opacity-70 blur-[90px] md:blur-[102px] ",
        isdark ? "bg-[#F200FF]" : "bg-[#D413CE]"
      )}
    />
  );
}
